import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { notifications } from '@mantine/notifications'
import { useAuth } from '@/contexts/AuthContext'
import { login } from '@/services/AuthService'
import LoginForm from '../organisms/LoginForm'

export default function LoginPage() {
  const navigate = useNavigate()
  const { refresh } = useAuth()
  const { t } = useTranslation()

  const handleSubmit = async (email: string, password: string) => {
    try {
      await login(email, password) // save token
      await refresh() // fetch /users/me
      navigate('/home') // go to dashboard
    } catch (e: any) {
      const detail = e.response?.data?.detail
      let message: string

      if (detail === 'Invalid credentials') {
        message = t('login.invalidCredentials', 'Credenciales incorrectas')
      } else if (detail === 'No roles assigned to this user') {
        message = t('login.noRoles', 'No tienes roles asignados')
      } else if (typeof detail === 'string' && detail.toLowerCase().includes('deactivated')) {
        message = t('login.deactivated', 'Tu municipio ha sido desactivado. Contacta con el administrador.')
      } else {
        message = detail || t('login.error', 'Error al iniciar sesión')
      }

      notifications.show({
        title: t('common.error', 'Error'),
        message,
        color: 'red',
      })
    }
  }

  return <LoginForm onSubmit={handleSubmit} />
}
